import React, { useContext, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Context } from "../../store";
import { useRouter } from "next/router";
import { handleLogout } from "../../utils/utils";
// import { faApple, faGooglePlay } from "@fortawesome/free-brands-svg-icons";
import {
  faAngleDown,
  faAngleRight,
  faHeart,
  faSignOutAlt,
} from "@fortawesome/free-solid-svg-icons";
// import {
//   appleStoreRedirectUrl,
//   GooglePlayRedirectUrl,
//   IMAGE_URL_2,
// } from "../../utils/constants";
import useStore from "../../store/UseStore";
import styles from "./Side-Navigation.module.scss";
import Link from "next/link";
import useRouting from "../../hooks/useRouting";
import DownloadTheAppCTA from "../v3/components/Common/DownloadTheAppCTA";

export default function SideNavigation({
  showSideMenu,
  toggleSideMenu,
  openLogin,
  type,
}) {
  const globalState = useContext(Context);
  const [showLegalAccordian, setShowLegalAccordian] = useState(false);
  const router = useRouter();
  const { userData } = useStore();
  const { routeToLoginConditionally } = useRouting();

  return (
    <div className={styles.sideNavigation}>
      {type !== "landing" ? (
        <div className={styles.navigation}>
          <nav style={{ right: `${showSideMenu ? "0px" : "-200%"}` }}>
            <div className={styles.title}>
              {/* <span onClick={toggleSideMenu}> */}
              <div className={styles.logo}>
                {/* {globalState?.userFullInformation?.user?.is_premium ? (
                  <img
                    alt="seekhoapp-logo"
                    onClick={() => router.push("/")}

                    src={seekhoAppPremiumIconURL}
                  />
                ) : (
                  <img
                    alt="seekhoapp-logo"
                    onClick={() => router.push("/")}

                    src={seekhoAppIconUrl}
                  />
                )} */}
              </div>
              <div onClick={toggleSideMenu} style={{ padding: 5 }}>
                <svg
                  height="30px"
                  width="24"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <title>cross-white</title>
                  <g fill="none" fillRule="evenodd">
                    <path d="M0 0h24v24H0z"></path>
                    <path
                      d="M6 6l12.73 12.73m0-12.73L6 18.73"
                      stroke="#fff"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </g>
                </svg>
              </div>
              {/* </span> */}
            </div>
            <ul>
              {!globalState?.user && (
                <li>
                  <a href={"/login"}>Login / Signup</a>
                </li>
              )}
              {globalState?.userFullInformation?.user.is_premium ? (
                ""
              ) : (
                <li onClick={toggleSideMenu}>
                  <a href="/premium">Premium</a>
                </li>
              )}

              <li onClick={toggleSideMenu}>
                {" "}
                <Link href={"/category"}>Categories</Link>
              </li>

              <li>
                <div
                  onClick={() => {
                    setShowLegalAccordian((prev) => !prev);
                  }}
                  className={styles.accordian}
                >
                  Legal
                  <div className={styles.icon}>
                    <FontAwesomeIcon
                      icon={showLegalAccordian ? faAngleDown : faAngleRight}
                    />
                  </div>
                </div>
                {showLegalAccordian && (
                  <div className={styles.accordianOptions}>
                    <div
                      className={styles.accordianOption}
                      onClick={() => {
                        router.push("/terms-and-conditions"),
                          toggleSideMenu(),
                          setShowLegalAccordian(false);
                      }}
                    >
                      {" "}
                      Terms and Condition{" "}
                    </div>
                    <div
                      className={styles.accordianOption}
                      onClick={() => {
                        router.push("/privacy-policy"),
                          toggleSideMenu(),
                          setShowLegalAccordian(false);
                      }}
                    >
                      {" "}
                      Privacy Policy{" "}
                    </div>
                    <div className={styles.accordianOption}>
                      <a href="mailto: support@seekhoapp.com"> Contact us </a>{" "}
                    </div>
                  </div>
                )}
              </li>

              {/* <li onClick={toggleSideMenu}>
              <Link href={"/about"}>About Us</Link>
            </li> */}
              <li>
                <a href="https://play.google.com/store/apps/details?id=com.seekho.android">
                  Download Seekhoapp
                </a>
              </li>
              {globalState?.user && (
                <li>
                  <a onClick={handleLogout}>
                    Logout <FontAwesomeIcon icon={faSignOutAlt} />
                  </a>
                </li>
              )}
            </ul>
            {!showLegalAccordian && (
              <span className={styles.footer}>
                Made With{" "}
                <FontAwesomeIcon
                  className={styles.icon}
                  size="1x"
                  icon={faHeart}
                ></FontAwesomeIcon>{" "}
                In India
              </span>
            )}
          </nav>
          {
            <div
              className={styles.backdrop}
              style={{ width: `${showSideMenu ? "100%" : "0"}` }}
              onClick={toggleSideMenu}
            ></div>
          }
        </div>
      ) : (
        <div className={styles.landing_navigation}>
          <nav style={{ right: `${showSideMenu ? "0px" : "-100%"}` }}>
            <ul>
              <li onClick={toggleSideMenu}>
                <a href="/app">Home</a>
              </li>
              {userData || globalState?.user ? (
                <li onClick={handleLogout}>
                  <a>Logout</a>
                </li>
              ) : (
                <li onClick={() => routeToLoginConditionally()}>
                  <a> Login / Signup</a>
                </li>
              )}
              <li onClick={toggleSideMenu}>
                <a href="/app">Watch Videos</a>
              </li>

              <li onClick={toggleSideMenu}>
                <a href="/category">Categories</a>
              </li>
              {/* <li onClick={toggleSideMenu}>
                {" "}
                <Link href={"/team"}>Team and Culture</Link>
              </li> */}
              <li onClick={toggleSideMenu}>
                {" "}
                <Link href="/blog">Blogs</Link>
              </li>
            </ul>

            {/* <div className={styles.google_playstore_cta}>
              <a
                href={
                  isIPhone() ? appleStoreRedirectUrl : GooglePlayRedirectUrl
                }
                target="_blank"
              >
                {isIPhone() ? (
                  <FontAwesomeIcon icon={faApple} />
                ) : (
                  <FontAwesomeIcon icon={faGooglePlay} />
                )}
                Download the app
                <img
                  alt="arrow"
                  src="assets/longArrow.svg"
                  className={styles.img_google}
                />
              </a>
            </div> */}

            <div className="w-fit mx-auto">
              <DownloadTheAppCTA
                onSection="Mobile Side Nav"
                className="w-full !px-10 !rounded-full font-medium"
              />
            </div>

            <div className={styles.accordianOptions}>
              <div
                className={styles.accordianOption}
                onClick={() => {
                  router.push("/privacy-policy");
                  toggleSideMenu();
                }}
              >
                {" "}
                Privacy Policy{" "}
              </div>
              <div
                className={styles.accordianOption}
                onClick={() => {
                  router.push("/terms-and-conditions");
                  toggleSideMenu();
                }}
              >
                {" "}
                Terms and Condition{" "}
              </div>
              <div
                className={styles.accordianOption}
                onClick={() => {
                  router.push("/terms-and-conditions");
                  toggleSideMenu();
                }}
              >
                {" "}
                Cancellation Policy{" "}
              </div>
            </div>
          </nav>
        </div>
      )}
    </div>
  );
}
